/**
 * Homepage: toggle body class when scrolled past hero top so the header can go solid.
 */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  const scrolledClass = 'shinzo-header-scrolled';
  const topThreshold = 8;

  function update() {
    document.body.classList.toggle(scrolledClass, window.scrollY > topThreshold);
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
})();
